import api from './axios';

/**
 * Phase E — block/unblock API wrappers.
 */
export const listBlocksRequest  = ()        => api.get('/chat/blocks');
export const storeBlockRequest  = (userId)  => api.post(`/chat/blocks/${userId}`);
export const deleteBlockRequest = (userId)  => api.delete(`/chat/blocks/${userId}`);
